/* global YMK*/
(function ($) {
  var isMobileLayout = (function () {
    return $(window).width() < 1025;
  })();

  class VTOLooksLandingPageFormatter {
    inFlightXHR;
    constructor($module) {
      this.activeState = {
        $activeCategory: $(),
        $activeLook: $(),
        $activeSubAction: $()
      };
      this.postActiveState = {
        $activeCategoryBlock: $(),
        $activeModalPanel: $()
      };
      this.nextActiveState = Object.assign({}, this.activeState);
      this.$module = $module;
      this.preSetup();
      this.setup();
      this.attachEventListeners();
      this.$module.addClass('attached');
    }
    isMobileIOS1741() {
      const userAgent = window.navigator.userAgent;
      const iosVersion = /OS 17_4_1 like Mac OS X/i;
      return iosVersion.test(userAgent);
    }
    preSetup() {
      this.$preloaderContainer = $('.js-vto-looks-landing__preloader', this.$module);
      this.$preloaderContent = $('.js-vto-looks-landing__preloader-content', this.$module);
      this.$preloaderButtons = $('.js-vto-looks-landing__preloader-btn', this.$module);
      this.$actionLinks = $('.js-vto-looks-landing-page-action-link', this.$module);
      this.$categoryLinks = $('.js-vto-looks-landing-page-category-link', this.$module);
    }
    setup(secondLoop) {
      const self = this;
      this.$preloaderContainer = $('.js-vto-looks-landing__preloader', this.$module);
      this.$preloaderContent = $('.js-vto-looks-landing__preloader-content', this.$module);
      this.$preloaderButtons = $('.js-vto-looks-landing__preloader-btn', this.$module);
      this.$actionLinks = $('.js-vto-looks-landing-page-action-link', this.$module);
      this.$categoryLinks = $('.js-vto-looks-landing-page-category-link', this.$module);
      this.$categoryGridBlock = $('.js-vto-looks-landing-page-category-block', this.$module);
      this.$individualLooks = $('.js-vto-looks-landing-page-single-look', this.$module);
      this.$contentStage = $('.js-vto-looks-landing-page-look-content-stage', this.$module);
      if (secondLoop) {
        return false;
      }
      this.$individualLooks.each(function () {
        var $thisLook = $(this);

        $thisLook.appendTo(self.$categoryGridBlock.first());
        $(this)
          .data('category')
          .split(',')
          .forEach(function (filter) {
            var trimmedFilter = filter.trim();

            if (trimmedFilter.length) {
              var selector = `js-filter-category--${self.sanitizeText(filter).toLowerCase()}`;

              $thisLook.addClass(selector);
            }
          });
      });
      this.$categoryGridBlock.children('*:not(.js-vto-looks-landing-page-single-look)').remove();
      this.$categoryLinks.each(function () {
        if ($(this).index() === 0) {
          return;
        }
        const thisCategorySelector = $(this).text();
        const $categoryBlock = self.$categoryGridBlock[0].cloneNode();
        const $looksResults = self.$individualLooks.filter(
          `.js-filter-category--${self.sanitizeText(thisCategorySelector).toLowerCase()}`
        );
        const $sortedLooksResults = $looksResults.clone().sort(function (a, b) {
          return $(a).find('.js-vto-looks-landing-page-single-look-title').text() >
            $(b).find('.js-vto-looks-landing-page-single-look-title').text()
            ? 1
            : -1;
        });

        $sortedLooksResults.appendTo($categoryBlock);
        self.$categoryGridBlock.parent().append($categoryBlock);
      });
      let preloaderHeight = window.innerHeight - 2;
      let contentSidePadding;
      let preloaderBtnHeight;
      if (window.innerWidth > 480 && window.innerWidth < 1025) {
        contentSidePadding = Math.ceil(((this.$preloaderContainer.width() - 2) / 2) - 199);
      } else {
        contentSidePadding = Math.ceil((this.$preloaderContainer.width() * 0.133) + 7.27);
      }      
      if (window.innerWidth < 1025) {
        this.$preloaderContainer.css(`height`, `${preloaderHeight}px`);
      }
      if (window.innerWidth < 480) {
        preloaderBtnHeight = Math.ceil((((this.$preloaderContainer.width() - (contentSidePadding * 2)) * 0.58) * 0.149) + 11.325);
        this.$preloaderButtons.css(`height`, `${preloaderBtnHeight}px`);
      }
      this.$preloaderContent.css(`padding`, `0 ${contentSidePadding}px`);
      this.setup(true);
    }
    sanitizeText(str) {
      return str ? str.trim().replace(/[^A-Z0-9]/gi, '-') : '';
    }
    updateURL() {
      let generatedURL = '';
      if (this.activeState.$activeLook.length) {
        generatedURL = this.activeState.$activeLook.data('permalink');
        try {
          const nid = this.activeState.$activeLook.data('nid');
          if (this.inFlightXHR) {
            this.inFlightXHR.abort();
          }
          this.inFlightXHR = $.ajax({
            url: '/elc_api/node/' + nid,
            success: (data) => {
              $('meta[name="description"]').attr('content', data[nid]['seo_description']);
              document.title = data[nid]['seo_title'];
            },
            error: (err) => {
              console.log(err);
            }
          });
        } catch (e) {
          console.log(e);
        }
      } else if (this.activeState.$activeCategory.length) {
        generatedURL = this.activeState.$activeCategory.attr('href');
      }
      // The first action is always the main overview
      if (
        this.activeState.$activeSubAction.length &&
        this.activeState.$activeSubAction.index() > 0 &&
        this.activeState.$activeSubAction.length
      ) {
        generatedURL += this.activeState.$activeSubAction.attr('href');
      }
      if (!this.isMobileIOS1741()) {
        // Empty space string resets the page URL
        window.history.replaceState(null, null, generatedURL ? generatedURL : ' ');
      }
    }
    attachEventListeners() {
      const self = this;

      this.$actionLinks.off('click.changeView').on('click.changeView', function (e) {
        e.preventDefault();
        self.setNextActiveState('$activeSubAction', $(this));
        self.render();
      });
      this.$categoryLinks.off('click.active').on('click.activate', function (e) {
        if (self.activeState.$activeCategory.is($(this))) {
          return false;
        }
        const $filteredLooks = self.get$filteredLooks($(this));
        const $activeLookInMultipleCategories = $filteredLooks.filter(
          `[data-permalink="${self.activeState.$activeLook.data('permalink')}"]`
        );

        e.preventDefault();
        self.setNextActiveState('$activeCategory', $(this));
        self.setNextActiveState(
          '$activeLook',
          $activeLookInMultipleCategories.length
            ? $activeLookInMultipleCategories
            : $filteredLooks.first()
        );
        self.render();
      });
      this.$individualLooks.off('click.activate').on('click.active', function (e) {
        if (self.activeState.$activeLook.is($(this))) {
          return false;
        }
        e.preventDefault();
        var applyLooksEvent = new Event('applyLooks');
        $(document).trigger(applyLooksEvent, [$(this)]);
        self.setNextActiveState('$activeLook', $(this));
        self.render();
      });
      $(document)
        .off('click.goBack')
        .on('click.goBack', '.js-vto-looks-landing-page-modal-back', function (e) {
          e.preventDefault();
          self.setNextActiveState('$activeSubAction', self.$actionLinks.first());
          self.render();
        });
    }
    get$filteredLooks($category) {
      const activeCategoryBlockIndex = $category.index();
      const $activeCategoryGridBlock = this.$categoryGridBlock.eq(activeCategoryBlockIndex);
      const $filteredLooks = $activeCategoryGridBlock.find(this.$individualLooks);

      return $filteredLooks;
    }
    setNextActiveState(stateName, value) {
      this.nextActiveState[stateName] = value;
    }
    getURLParameter() {
      const splitPath = location.pathname.split('/');

      if (splitPath[2]) {
        return location.pathname.substring(location.pathname.indexOf('/'));
      }

      return false;
    }
    // Handle setting of launch state
    launch() {
      const urlFragments = {
        nextCategory: this.getURLParameter('section'),
        nextLook: this.getURLParameter('look'), // if a category is selected, don't show a look
        nextAction: location.hash
      };

      this.nextActiveState = {
        $activeCategory: this.$categoryLinks.first(),
        $activeLook: this.$individualLooks.first(),
        $activeSubAction: this.$actionLinks.first()
      };
      var $findCategory = this.$categoryLinks.filter(`[href*="${urlFragments.nextCategory}"]`);

      // When we have a look, do not filter the categories
      if (urlFragments.nextCategory && $findCategory.length) {
        // We do not have a loaded look, we want to specifically filter by categories
        this.nextActiveState.$activeCategory = $findCategory;
        this.nextActiveState.$filteredLooks = this.get$filteredLooks(
          this.nextActiveState.$activeCategory
        );
        this.nextActiveState.$activeLook = this.nextActiveState.$filteredLooks.first();
      } else if (urlFragments.nextLook) {
        this.nextActiveState.$filteredLooks = this.get$filteredLooks(
          this.nextActiveState.$activeCategory
        );
        this.nextActiveState.$activeLook = this.nextActiveState.$filteredLooks.filter(
          `[data-permalink="${urlFragments.nextLook}"]`
        );
      }
      if (urlFragments.nextAction && urlFragments.nextAction.length) {
        this.nextActiveState.$activeSubAction = this.$actionLinks.filter(
          `[href="${urlFragments.nextAction}"]`
        );
      } else {
        this.nextActiveState.$activeSubAction = this.$actionLinks.first();
      }
      this.render();
    }
    optimizeAssets($container) {
      // Set akamai optimized value on these properties
      var checkAttributes = ['data-src', 'src', 'data-srcset', 'srcset'];
      // Check if this element preserved a source
      var checkAndPreserveOriginal = function ($elem) {
        if (!$elem.attr('data-original-source')) {
          let originalSource = '';

          if ($elem.attr('data-src')) {
            originalSource = $elem.attr('data-src');
          } else if ($elem.attr('data-srcset')) {
            originalSource = $elem.attr('data-srcset');
          } else if ($elem.attr('src')) {
            originalSource = $elem.attr('src');
          } else if ($elem.attr('srcset')) {
            originalSource = $elem.attr('srcset');
          }
          $elem.attr('data-original-source', originalSource);
        }
      };
      var setOptimizedSrc = function ($elem) {
        checkAttributes.forEach(function (attr) {
          if ($elem.attr(attr) && $elem.attr('data-original-source')) {
            var $mantleWrapper = $elem.closest('.mantle-media-asset');
            var widthToUse =
              $mantleWrapper.width() <= 0 ? $elem.parent().width() : $mantleWrapper.width(); // depending which image, the width may not be set
            const newURL = `${$elem.attr('data-original-source')}?imwidth=${widthToUse}`;

            $elem.attr(attr, newURL);
          }
        });
      };

      $container.find('.mantle-media-asset img, source').each(function () {
        checkAndPreserveOriginal($(this));
        setOptimizedSrc($(this));
      });
    }
    render() {
      let changedRenderKeys = [];
      let hardRenderFn = () => {
        $(document).trigger('VTOLooksLandingPage.clearContentStage');
        this.updateURL();
        this.renderLookContentPanels();
        this.optimizeAssets(this.$module);
        this.postRenderHook();
        if (changedRenderKeys.includes('$activeLook')) {
          this.applyActiveLook();
        }
      };

      for (const renderKey in this.nextActiveState) {
        if (
          !this.activeState[renderKey] ||
          !this.activeState[renderKey].is(this.nextActiveState[renderKey])
        ) {
          changedRenderKeys.push(renderKey);
          if (renderKey === '$activeLook') {
            this.activeState[renderKey].attr('aria-expanded', false);
            this.nextActiveState[renderKey].attr('aria-expanded', true);
          }
          if (this.activeState[renderKey]) {
            if (this.activeState[renderKey].length) {
              this.activeState[renderKey].removeClass('active');
            }
            this.nextActiveState[renderKey].addClass('active');
          }
        }
      }

      this.activeState = Object.assign({}, this.nextActiveState);
      if (changedRenderKeys.length && changedRenderKeys !== ['$activeSubAction']) {
        hardRenderFn();
      }
      // post render changes
      if (this.postActiveState.$activeCategoryBlock.length) {
        this.postActiveState.$activeCategoryBlock.removeClass('active');
      }
      this.postActiveState.$activeCategoryBlock = this.$categoryGridBlock
        .eq(this.activeState.$activeCategory.index())
        .addClass('active');
    }
    postRenderHook() {
      const self = this;

      setTimeout(function () {
        const targetActionId = self.activeState.$activeSubAction.attr('href');
        if (self.postActiveState.$activeModalPanel.length) {
          self.postActiveState.$activeModalPanel.removeClass('active');
        }

        self.postActiveState.$activeModalPanel =
          targetActionId === '#'
            ? $()
            : self.$contentStage
                .find(
                  `.js-vto-looks-landing-page-single-look-content-selector[data-action-id="${targetActionId.slice(
                    '1'
                  )}"]`
                )
                .closest('.js-vto-looks-landing-page-modal')
                .addClass('active');

        if (isMobileLayout) {
          $('html').toggleClass(
            'vto-looks-landing-page-no-scroll',
            self.postActiveState.$activeModalPanel.length > 0
          );
        } else {
          $(window).scrollTo(
            self.postActiveState.$activeModalPanel.length === 0
              ? 0
              : self.postActiveState.$activeModalPanel.position().top
          );
        }
      }, 0);
    }
    renderLookContentPanels() {
      if (!this.activeState.$activeLook.length) {
        return false;
      }
      const self = this;
      const $lookContent = this.$categoryGridBlock
        .first()
        .find(`[data-permalink="${this.activeState.$activeLook.data('permalink')}"]`)
        .first()
        .find('.js-vto-looks-landing-page-single-look-content');
      const $productsContent = $lookContent.find(
        '.js-vto-looks-landing-page-single-look-content-products'
      );
      const $blockContent = $lookContent.find(
        '.js-vto-looks-landing-page-single-look-content-block'
      );
      const $contentTemplate = $('.js-vto-looks-landing-page-content-template', this.$module);
      const $newContent = $lookContent.find(
        '.js-vto-looks-landing-page-single-look-content-selector'
      );

      $newContent.each(function () {
        let actionId = $(this).data('actionId');
        let $modalTarget;
        let textToPut = self.$actionLinks.filter(`[href="#${actionId}"]`).data('modal-title');
        self.$contentStage.append($contentTemplate.html());
        $modalTarget = self.$contentStage.find('.js-vto-looks-landing-page-modal-body').last();
        $modalTarget.parent().find('.js-vto-looks-landing-page-modal-title').last().text(textToPut);
        $(this).appendTo($modalTarget);
      });
      $(document)
        .off('VTOLooksLandingPage.clearContentStage')
        .on('VTOLooksLandingPage.clearContentStage', function () {
          if ($productsContent.length) {
            $productsContent.appendTo($lookContent);
          }
          if ($blockContent.length) {
            $blockContent.appendTo($lookContent);
          }
          self.$contentStage.html('');
        });
      this.$contentStage.find('.slick-initialized').each(function () {
        try {
          if ($(this)[0].slick) {
            $(this)[0].slick.refresh();
          }
        } catch (e) {
          console.log(e);
        }
      });
    }
    refreshColumnHeightOnLargeLayout(height) {
      var $targets = this.$module.find('.js-vto-looks-landing-page-column');

      if (isMobileLayout) {
        $targets.css({ height: '' });
      } else {
        $targets.css({ height });
      }
    }
    applyActiveLook() {
      if (window.YMK) {
        try {
          YMK.applyMakeupByLook(this.activeState.$activeLook.data('vto'));
        } catch (e) {
          console.log(e);
        }
      }
    }
  }

  Drupal.behaviors.VTOLooksLandingPageFormatterV1 = {
    attach: function (context) {
      const $module = $('.js-vto-looks-landing-page-formatter--v1:not(.attached)', context);
      const vtoLooksLandingPage = new VTOLooksLandingPageFormatter($module);
      vtoLooksLandingPage.launch();
      // Detect YMK click to close/hide preloader.
      window.focus();
      window.addEventListener('blur',function(){
        if (document.activeElement.id == 'YMK-module-iframe') {
          $('.js-vto-looks-landing__preloader').hide();
          $('#YMK-module').css('position', 'relative');
        }
      });
      $(document).on('VTOLooksLandingPage.youcamLoadedAtHeight', function (event, height) {
        vtoLooksLandingPage.refreshColumnHeightOnLargeLayout(height);
        vtoLooksLandingPage.applyActiveLook();
      });
      $(window).on('resize.VTOLooksLandingPage', function () {
        vtoLooksLandingPage.optimizeAssets($module);
      });
    }
  };
})(jQuery);
